<div [formGroup]="searchForm" class="row">
  <div class="col-4 col-md-2 form-group required">
    <div class="row pb-3 pb-md-2">
      <div class="col-12"><span
          class="control-label"
          [ngClass]="{'text-danger': invalidZip}">{{'common.formFieldsLabels.zip' | translate}}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-12 input-group">
        <input

            class="form-control"
            formControlName="zip"
            mask="00000"
            type="text"
            [ngClass]="{'is-invalid': invalidZip}"
            AutocompleteOffDirective
        >
        <div *ngIf="invalidZip"
                         class="invalid-feedback">{{'common.formErrors.required' | translate}}</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 form-group">
    <div class="row pb-3 pb-md-2">
      <div class="col-12"><span
          class="control-label">{{'common.formFieldsLabels.pcpName' | translate}}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-12 input-group">
        <input
            [patterns]="alphaSpaceRegEx"
            class="form-control"
            formControlName="pcpName"
            mask="S*"
            type="text"
            AutocompleteOffDirective
        >
      </div>
    </div>
  </div>
</div>

<div class="row mt-3">
  <div class="col-7 col-md-4 col-lg-3">
    <button
        (click)="openPcpSelectionModal()"
        class="btn btn-success text-capitalize px-5">{{'common.buttonLabels.searchPcp' | translate}}</button>
  </div>
</div>
